import React from 'react';

const Priorities = () => {
  return (
    <section className="py-20 bg-yellow-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-blue-900 mb-6">Warum ich kandidiere</h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-xl text-blue-800 font-semibold">
            Ich möchte Lauingen aktiv mitgestalten.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h3 className="text-3xl font-bold text-blue-900 mb-8">Meine Vision für Lauingen</h3>
            <ul className="space-y-6">
              <li className="flex items-start">
                <div className="bg-blue-600 w-4 h-4 rounded-full mt-1 mr-4 flex-shrink-0"></div>
                <span className="text-lg text-blue-800 font-medium">Generationsübergreifend gestalten</span>
              </li>
              <li className="flex items-start">
                <div className="bg-blue-600 w-4 h-4 rounded-full mt-1 mr-4 flex-shrink-0"></div>
                <span className="text-lg text-blue-800 font-medium">Lebenswerte, soziale, vernetzte und zukunftsfähige Stadtpolitik</span>
              </li>
              <li className="flex items-start">
                <div className="bg-blue-600 w-4 h-4 rounded-full mt-1 mr-4 flex-shrink-0"></div>
                <span className="text-lg text-blue-800 font-medium">Mit offenem Ohr, Tatkraft und digitalem Sachverstand</span>
              </li>
            </ul>
          </div>
          
          <div className="bg-blue-600 text-white p-8 rounded-lg">
            <h3 className="text-2xl font-bold mb-6 text-yellow-400">Meine Priorität im Stadtrat</h3>
            <div className="bg-white bg-opacity-10 p-6 rounded-lg">
              <h4 className="text-xl font-bold mb-4 text-yellow-400">Bürgernähe durch Vernetzung</h4>
              <p className="text-lg leading-relaxed">
                Den direkten Dialog stärken und Lauingen als moderne Wohlfühlstadt positionieren.
              </p>
            </div>
          </div>
        </div>
        
        <div className="bg-blue-600 text-white p-8 rounded-lg text-center">
          <h3 className="text-3xl font-bold mb-4 text-yellow-400">
            Bürgernähe durch Vernetzung
          </h3>
          <p className="text-xl leading-relaxed max-w-4xl mx-auto">
            Mein Ziel ist es, den direkten Dialog zwischen Bürgern und Stadtrat zu stärken 
            und Lauingen als moderne, lebenswerte Wohlfühlstadt zu positionieren. 
            Durch meine Erfahrung in der digitalen Vernetzung und mein soziales Engagement 
            bringe ich die nötigen Kompetenzen mit, um diese Vision umzusetzen.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Priorities;